import {
    DEALERFEEEXCELPDFFILE_FAILED,
    DEALERFEEEXCELPDFFILE_SUCCESS,
    RESET_DEALERFEEEXCELPDFFILE,
    LOADING_DEALERFEEEXCELPDFFILE,
    NETWORK_ERROR_DEALERFEEEXCELPDFFILE
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERFEEEXCELPDFFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERFEEEXCELPDFFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERFEEEXCELPDFFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERFEEEXCELPDFFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERFEEEXCELPDFFILE:
            return (state = initialState);
        default:
            return state;
    }
};